"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Subscription = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _subscriptionService = require("@insided/shared/services/subscriptionService");

/**
 * Subscribe to a topic
 * @param publicId - The public ID of the topic to subscribe to
 * @returns Promise resolving to the axios response with status and data
 * @throws Error if the request fails
 * @example
 * const response = await ChWebSdk.Subscription.subscribeTopic('topic-123')
 * console.log(response.status, response.data)
 */
function subscribeTopic(_x) {
  return _subscribeTopic.apply(this, arguments);
}
/**
 * Unsubscribe from a topic
 * @param publicId - The public ID of the topic to unsubscribe from
 * @returns Promise resolving to the axios response with status and data
 * @throws Error if the request fails
 * @example
 * const response = await ChWebSdk.Subscription.unsubscribeTopic('topic-123')
 * console.log(response.status, response.data)
 */


function _subscribeTopic() {
  _subscribeTopic = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(publicId) {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (publicId) {
              _context.next = 2;
              break;
            }

            throw new Error('Topic publicId is required');

          case 2:
            _context.prev = 2;
            _context.next = 5;
            return (0, _subscriptionService.subscribeTopic)(publicId);

          case 5:
            return _context.abrupt("return", _context.sent);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](2);
            console.error('Error subscribing to topic:', _context.t0);
            throw _context.t0;

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 8]]);
  }));
  return _subscribeTopic.apply(this, arguments);
}

function unsubscribeTopic(_x2) {
  return _unsubscribeTopic.apply(this, arguments);
}
/**
 * Subscribe to a category
 * @param categoryId - The ID of the category to subscribe to
 * @returns Promise resolving to the axios response with status and data
 * @throws Error if the request fails
 * @example
 * const response = await ChWebSdk.Subscription.subscribeToCategory(123)
 * console.log(response.status, response.data)
 */


function _unsubscribeTopic() {
  _unsubscribeTopic = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(publicId) {
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (publicId) {
              _context2.next = 2;
              break;
            }

            throw new Error('Topic publicId is required');

          case 2:
            _context2.prev = 2;
            _context2.next = 5;
            return (0, _subscriptionService.unsubscribeTopic)(publicId);

          case 5:
            return _context2.abrupt("return", _context2.sent);

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](2);
            console.error('Error unsubscribing from topic:', _context2.t0);
            throw _context2.t0;

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 8]]);
  }));
  return _unsubscribeTopic.apply(this, arguments);
}

function subscribeToCategory(_x3) {
  return _subscribeToCategory.apply(this, arguments);
}
/**
 * Unsubscribe from a category
 * @param categoryId - The ID of the category to unsubscribe from
 * @returns Promise resolving to the axios response with status and data
 * @throws Error if the request fails
 * @example
 * const response = await ChWebSdk.Subscription.unsubscribeFromCategory(123)
 * console.log(response.status, response.data)
 */


function _subscribeToCategory() {
  _subscribeToCategory = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(categoryId) {
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (categoryId) {
              _context3.next = 2;
              break;
            }

            throw new Error('Category ID is required');

          case 2:
            _context3.prev = 2;
            _context3.next = 5;
            return (0, _subscriptionService.subscribeCategory)(categoryId);

          case 5:
            return _context3.abrupt("return", _context3.sent);

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](2);
            console.error('Error subscribing to category:', _context3.t0);
            throw _context3.t0;

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[2, 8]]);
  }));
  return _subscribeToCategory.apply(this, arguments);
}

function unsubscribeFromCategory(_x4) {
  return _unsubscribeFromCategory.apply(this, arguments);
}
/**
 * Get subscription status for a topic
 * @param publicId - The public ID of the topic to check
 * @returns Promise resolving to boolean indicating if subscribed
 * @throws Error if the request fails
 * @example
 * const isSubscribed = await ChWebSdk.Subscription.getTopicSubscriptionStatus('topic-123')
 * console.log(isSubscribed) // true or false
 */


function _unsubscribeFromCategory() {
  _unsubscribeFromCategory = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(categoryId) {
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (categoryId) {
              _context4.next = 2;
              break;
            }

            throw new Error('Category ID is required');

          case 2:
            _context4.prev = 2;
            _context4.next = 5;
            return (0, _subscriptionService.unsubscribeCategory)(categoryId);

          case 5:
            return _context4.abrupt("return", _context4.sent);

          case 8:
            _context4.prev = 8;
            _context4.t0 = _context4["catch"](2);
            console.error('Error unsubscribing from category:', _context4.t0);
            throw _context4.t0;

          case 12:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[2, 8]]);
  }));
  return _unsubscribeFromCategory.apply(this, arguments);
}

function getTopicSubscriptionStatus(_x5) {
  return _getTopicSubscriptionStatus.apply(this, arguments);
}
/**
 * Get subscription status for a category
 * @param categoryId - The ID of the category to check
 * @returns Promise resolving to boolean indicating if subscribed
 * @throws Error if the request fails
 * @example
 * const isSubscribed = await ChWebSdk.Subscription.getCategorySubscriptionStatus(123)
 * console.log(isSubscribed) // true or false
 */


function _getTopicSubscriptionStatus() {
  _getTopicSubscriptionStatus = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(publicId) {
    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (publicId) {
              _context5.next = 2;
              break;
            }

            throw new Error('Topic publicId is required');

          case 2:
            _context5.prev = 2;
            _context5.next = 5;
            return (0, _subscriptionService.getSubscriptionStatus)(publicId);

          case 5:
            return _context5.abrupt("return", _context5.sent);

          case 8:
            _context5.prev = 8;
            _context5.t0 = _context5["catch"](2);
            console.error('Error getting topic subscription status:', _context5.t0);
            throw _context5.t0;

          case 12:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[2, 8]]);
  }));
  return _getTopicSubscriptionStatus.apply(this, arguments);
}

function getCategorySubscriptionStatus(_x6) {
  return _getCategorySubscriptionStatus.apply(this, arguments);
}
/**
 * Subscription API service
 */


function _getCategorySubscriptionStatus() {
  _getCategorySubscriptionStatus = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(categoryId) {
    return _regenerator.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (categoryId) {
              _context6.next = 2;
              break;
            }

            throw new Error('Category ID is required');

          case 2:
            _context6.prev = 2;
            _context6.next = 5;
            return (0, _subscriptionService.getCategorySubscriptionStatus)(categoryId);

          case 5:
            return _context6.abrupt("return", _context6.sent);

          case 8:
            _context6.prev = 8;
            _context6.t0 = _context6["catch"](2);
            console.error('Error getting category subscription status:', _context6.t0);
            throw _context6.t0;

          case 12:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[2, 8]]);
  }));
  return _getCategorySubscriptionStatus.apply(this, arguments);
}

var Subscription = {
  subscribeTopic: subscribeTopic,
  unsubscribeTopic: unsubscribeTopic,
  subscribeToCategory: subscribeToCategory,
  unsubscribeFromCategory: unsubscribeFromCategory,
  getTopicSubscriptionStatus: getTopicSubscriptionStatus,
  getCategorySubscriptionStatus: getCategorySubscriptionStatus
};
exports.Subscription = Subscription;